<template>
  <vxe-toolbar class="bg-white-color p-16px">
    <template #buttons>
      <div class="h-input-group">
        <Select :datas="monthList" v-model="params.start" :deletable="false"/>
        <span class="h-input-addon">至</span>
        <Select :datas="monthList" v-model="params.end" :deletable="false"/>
      </div>
      <!-- <DatePicker v-model="params.start" :clearable="false" :option="{end:params.end}"/>
      <span class="mx-8px">至</span>
      <DatePicker v-model="params.end" :clearable="false" :option="{start:params.start}"/> -->
      <Button @click="loadList()" class="mx-8px" color="primary" icon="fa fa-search">查询</Button>
    </template>
    <template #tools>
      <vxe-button  v-print="'#printSection'" content="打印" icon="fa fa-print"/>
      <vxe-button @click="exportClick" content="导出" icon="fa fa-download"/>
    </template>
  </vxe-toolbar>
  <div class="flex-1 h-0px overflow-y bg-white-color">
    <vxe-table :data="cashList" class="mx-16px mb-8px" border :highlight-current-row="false">
      <vxe-column title="编码" field="code"/>
      <vxe-column title="收支类别" field="name"/>
      <vxe-column title="收入总额" field="sr" align="right" formatter="toMoney"/>
      <vxe-column title="支出总额" field="zc" align="right" formatter="toMoney"/>
      <vxe-column title="收入笔数" field="srbs" align="right"/>
      <vxe-column title="支出笔数" field="zcbs" align="right"/>
    </vxe-table>
    <vxe-table :data="bankList" class="mx-16px mb-8px" border :highlight-current-row="false">
      <vxe-column title="编码" field="code"/>
      <vxe-column title="收支类别" field="name"/>
      <vxe-column title="收入总额" field="sr" align="right" formatter="toMoney"/>
      <vxe-column title="支出总额" field="zc" align="right" formatter="toMoney"/>
      <vxe-column title="收入笔数" field="srbs" align="right"/>
      <vxe-column title="支出笔数" field="zcbs" align="right"/>
    </vxe-table>
    <vxe-table row-class-name="highlight-aggregate" :data="aggregateData" class="mx-16px mb-8px" border :show-header="false" :highlight-current-row="false">
      <vxe-column title="编码" field="code"/>
      <vxe-column title="收支类别" field="name"/>
      <vxe-column title="收入总额" field="sr" align="right" formatter="toMoney"/>
      <vxe-column title="支出总额" field="zc" align="right" formatter="toMoney"/>
      <vxe-column title="收入笔数" field="srbs" align="right"/>
      <vxe-column title="支出笔数" field="zcbs" align="right"/>
    </vxe-table>
    <div class="pl-20px">
      <div class="red-color font-bold">提示：</div>
      内部转账，不计入收支
    </div>
  </div>
  <!-- jxd原生打印区域 -->
  <div style="width: 0;height: 0;overflow: hidden;">
    <div id="printSection">
      <table class="w-full mx-16px mb-8px border-collapse" style="
        width: 98%;
        border: #ccc 1px solid;
        border-spacing: 0;
        border-collapse: collapse;
      ">
        <thead style="background-color: #f2f2f2;">
          <tr>
            <th style="padding: 8px;border: 1px solid #ccc; font-weight: bold;text-align: center;">编码</th>
            <th style="padding: 8px; border: 1px solid #ccc; font-weight: bold;text-align: center;">收支类别</th>
            <th style="padding: 8px; border: 1px solid #ccc; font-weight: bold;text-align: center;">收入总额</th>
            <th style="padding: 8px; border: 1px solid #ccc; font-weight: bold;text-align: center;">支出总额</th>
            <th style="padding: 8px; border: 1px solid #ccc; font-weight: bold;text-align: center;">收入笔数</th>
            <th style="padding: 8px; border: 1px solid #ccc; font-weight: bold;text-align: center;">支出笔数</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in allList" :key="index">
            <td style="padding: 8px; border: 1px solid #ccc;text-align: center;">{{ item.code }}</td>
            <td style="padding: 8px; border: 1px solid #ccc;text-align: center;">{{ item.name }}</td>
            <td style="padding: 8px; border: 1px solid #ccc;text-align: center;">{{ item.sr == 0 ? '' : item.sr }}</td>
            <td style="padding: 8px; border: 1px solid #ccc;text-align: center;">{{ item.zc == 0 ? '' : item.zc }}</td>
            <td style="padding: 8px; border: 1px solid #ccc;text-align: center;">{{ item.srbs == 0 ? '' : item.srbs }}</td>
            <td style="padding: 8px; border: 1px solid #ccc;text-align: center;">{{ item.zcbs == 0 ? '' : item.zcbs }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2019-2020金华企客观网络科技有限公司All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2020年08月08日</li>
 * <li>@author     : ____′↘企万慧</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
export default {
  name: "IoSummary"
}
</script>

<script setup>
import {ref} from "vue";
import manba from "manba";
import {useStore} from "vuex";
import CashierReport from "@/api/CashierReport";
import {layer} from "@layui/layer-vue";
import htmlToExcel from '@/utils/htmlToExcel'; // 直接导入 htmlToExcel 函数 
import Checkout from "@/api/checkout";

const store = useStore();
const currentAccountDate = manba(store.state.currentAccountSets.currentAccountDate);
const startDate = ref(currentAccountDate.startOf(manba.MONTH).format("YYYY-MM"));
const endDate = ref(currentAccountDate.endOf(manba.MONTH).format("YYYY-MM"));

const cashList = ref([]);
const bankList = ref([]);
const allList = ref([]);

const params = ref({
  start: startDate,
  end: endDate,
})

const summaryCol = ['sr', 'zc', 'srbs', 'zcbs'];

const aggregateData = ref([])

const monthList = ref([]);
Checkout.list().then(({data}) => {
  monthList.value = data.map(val => {
    // return {key: val.checkYear + "-" + val.checkMonth, title: val.checkYear + "年" + val.checkMonth + "月"}
    //jxd,处理弹出的期间未选中
    const month = val.checkMonth < 10 ? '0' + val.checkMonth : val.checkMonth;
    return {key: val.checkYear + "-" + month, title: val.checkYear + "年" + month + "月"}
  })
})


const exportClick = () => {
  htmlToExcel.exportExcel("资金报表-按收支类别.xlsx", "#printSection");
}

const loadList = () => {
  const aggregateDataRow = {name: '总计'};
  const cashFooterData = {name: '收入合计'};
  const bankFooterData = {name: '支出合计'};

  const loadId = layer.load(1);
  CashierReport.ioTypeSummary(params.value).then(({data}) => {
    (data || []).forEach(val => {
      for (let i = 0; i < summaryCol.length; i++) {
        const fieldName = summaryCol[i];
        if (val.type === '收') {
          cashFooterData[fieldName] = (cashFooterData[fieldName] || 0) + val[fieldName] || 0;
        } else {
          bankFooterData[fieldName] = (bankFooterData[fieldName] || 0) + val[fieldName] || 0;
        }
        aggregateDataRow[fieldName] = (aggregateDataRow[fieldName] || 0) + (val[fieldName] || 0)
      }
    })
    aggregateData.value = [aggregateDataRow];
    cashList.value = (data || []).filter(val => val.type === '收');
    cashList.value.push(cashFooterData);
    bankList.value = (data || []).filter(val => val.type === '支');
    bankList.value.push(bankFooterData);
    //jxd合并的用于原生打印数据
    allList.value = [...cashList.value, ...bankList.value,...aggregateData.value];
    allList.value.forEach(val => {
      if(!val.code){val.code = ''}
      if(val.initialBalance){val.initialBalance = Number(val.initialBalance).toFixed(2);}
      if(val.sr){val.sr = Number(val.sr).toFixed(2)}
      if(val.zc){val.zc = Number(val.zc).toFixed(2)}
      if(val.balance){val.balance = Number(val.balance).toFixed(2)}
    })
  }).finally(() => layer.close(loadId))
}
loadList()
</script>
